import React from 'react'

import AnalyticsSectionContent, { IAnalyticsSectionContentProps } from './AnalyticsSectionContent'

const TopQueriesWithClicks: React.SFC<IAnalyticsSectionContentProps> = (props) => (
  <AnalyticsSectionContent title="Top Queries with Clicks" {...props} />
)

export default TopQueriesWithClicks
